import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-kf-configuration-edit-step-bar',
  templateUrl: './kf-configuration-edit-step-bar.component.html',
  styleUrls: ['./kf-configuration-edit-step-bar.component.scss']
})
export class KfConfigurationEditStepBarComponent implements OnInit {

  @Input()
  currentStep!: number;
  @Input()
  selectedIndex!: number|undefined;
  @Input()
  selectedIndex2!: number|undefined;
  @Input()
  step2Completed!: boolean;

  @Output()
  loadStep: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  step(value: number): void {
    // if (this.currentStep < value) {
    //   if (value === 2 && this.step2Completed) {
    //     this.loadStep.emit(value);
    //   }
    //   if (value === 3 && this.step2Completed) {
    //     this.loadStep.emit(value);
    //   }
    // }
    // else {
      this.loadStep.emit(value);
    // }
  }

}
